// extracted by mini-css-extract-plugin
export default {"process-wrapper":"lan_process-wrapper__3XryJ","process":"lan_process__w7R0n","arrow-wrapper":"lan_arrow-wrapper__rl+Cw","fast-network-title":"lan_fast-network-title__cgrp-"};